import HundredBricksAPIError from '../HundredBricksAPIError';
class ResendUnusualAccessError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ResendUnusualAccessError', ...args);
    }
}
export default ResendUnusualAccessError;
